import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import { RootStateDto } from "dto/redux/store-dto";
import ErrorResponseDto from "dto/services/error-response-dto";
import AppResourceObjectInputDto from "dto/components/pages/resources/app-resource-object-input-dto";

import AppInput from "components/app-input";
import AppResourceArrayWrapper from "./app-resource-array-wrapper";

const AppResourceObjectInput = ({ detail }: AppResourceObjectInputDto) => {
	const [objKey, setObjKey] = useState<string[]>([]);
	const { customerId } = useSelector((state: RootStateDto) => state.profile);

	const formik = useFormik<Record<string, any>>({
		initialValues: {},
		onSubmit: async (values) => {
			const payload = {
				id: detail.templateId,
				customerId: customerId,
				template: detail.activeTemplate,
				page: detail.page,
				key: detail.key,
				type: detail.type,
				placeholder: detail.placeholder,
				isArray: detail.isArray,
				value: values,
			};

			try {
				await api.post.resources.update(payload);

				serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);
			} catch (error) {
				const err = error as Error | ErrorResponseDto;

				serveRequestErrors(err);
			}
		},
	});

	useEffect(() => {
		if (detail.value) {
			let listOfKey = [];

			for (const [key, value] of Object.entries(detail.value)) {
				formik.registerField(key, {});

				formik.setFieldValue(key, value);

				listOfKey.push(key);
			}
			setObjKey(listOfKey);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detail.value]);

	return (
		<AppResourceArrayWrapper onUpdate={formik.handleSubmit} title={detail?.label || detail.key}>
			<>
				{objKey.map((item) => (
					<AppInput key={item} type="text" name={item} label={item} value={formik.values[item] || ""} placeholder="" onChange={formik.handleChange} />
				))}
			</>
		</AppResourceArrayWrapper>
	);
};

export default AppResourceObjectInput;
